

import React from 'react';
import { navigateTabsWithQueries } from '../types/cutterState';
import { Link, Stack, Typography,Box, TypographyProps } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CopyToClipboard } from './CopyToClipBoard';
import { ContentCopy } from '@mui/icons-material';


type ToSearchLinksProps = {
    strInput: string;
    delimiter?: string;
} & TypographyProps;

const ToSearchLinks: React.FC<ToSearchLinksProps> = ({ strInput, delimiter = " ", sx, ...typographyProps }) => {

    const navigate = useNavigate();

    const sentence: string[] = (strInput ?? '').split(delimiter).slice(0, 5);

    return (
        <Box component={Stack} direction="row" alignItems="center" justifyContent='flex-start' >
            {
                sentence.map((value, idx) => {
                    return (
                        <React.Fragment key={idx}>
                            <Link key={idx} href="#" underline="hover" onClick={e => {
                                if (value.length >= 3) { navigateTabsWithQueries(navigate, 'search', value); } else { e.preventDefault(); }
                            }} sx={{ textDecoration: 'none',
                                "&:hover": { textDecoration: 'underline darkgrey' }
                            }} >
                                <Typography sx={{...sx }} {...typographyProps}>{value}</Typography>
                            </Link>&nbsp;
                        </React.Fragment>
                    )
                })
            }
            <CopyToClipboard
                TextToCopy={`${strInput}`} title={`Copy '${strInput}' to clipboard`}
                AckMessage={`'${strInput}' copied to clipboard`}>
                <ContentCopy sx={{ color: 'default', padding: 0, fontSize: '0.6rem' }} titleAccess={`Copy '${strInput}' to clipboard`} />
            </CopyToClipboard>
        </Box>
    );
};

export default ToSearchLinks;
